// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2JsQE","rightAdornment":"Header_rightAdornment__3HvPK"};